var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    attrs: { type: "radio" },
    domProps: { checked: _vm.$_isChecked },
    on: { click: _vm.$_toggleState }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }